import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { InputTextComponent } from '../../FormInputs/InputText/InputText';

interface PassedProps {
    explanation?: string | JSX.Element;
}

export const DriverLicenseNumber = ({
    value,
    isErrored,
    onChange,
    explanation,
    intl,
    placeholder = '',
    isRequired = false,
}: FormFieldComponentProps & PassedProps) => {
    const getDefaultExplanation = () => (!isRequired
        ? (
            <FormattedHTMLMessage
                id="optional"
                defaultMessage="Optional"
            />
        )
        : '');
    return (
        <div className="sid-field sid-driver-license-number">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-driver-license-number">
                <div className={`sid-field__label-with-explanation sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <div className={`sid-field__label${isRequired ? ' sid-field__label--required' : ''} `}>
                        <FormattedHTMLMessage
                            id="driverLicenseNumber"
                            defaultMessage="Driver license number"
                        />
                    </div>
                    <div className="sid-field__label-explanation">
                        {
                            explanation || getDefaultExplanation()
                        }
                    </div>
                </div>
            </label>

            <InputTextComponent
                id="driver-license-number"
                isErrored={isErrored}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder
                    || intl.formatMessage({
                        id: 'driverLicenseNumberPlaceholder',
                        defaultMessage: isRequired ? 'Driver license number*' : 'Driver license number',
                    })}
                refId="driverLicenseNumber"
                value={value}
            />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidDriverLicenseNumber"
                            defaultMessage="Invalid driver license number"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export const DriverLicenseNumberComponent = injectIntl(DriverLicenseNumber);
